import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@tds/core-checkbox';
import {
  customerAuthorized,
  customerAuthorizedValcan
} from '../../utils/constant';
import { FieldWrapper } from './css';

const FieldCheckbox = ({ data }) => {
  const {
    ref,
    checked,
    name,
    label,
    value,
    onChange,
    readonly,
    // eslint-disable-next-line no-unused-vars
    mainLabel,
    longLabel = '',
    formFields
  } = data;
  const LabelLogic =
    formFields && formFields.telusOptikTvComments
      ? label.split('($')[0]
      : label;
  /**
   * for fields whose label value does not fit in 'label' due to max 255 character limit
   */
  const labelValue = longLabel !== '' ? longLabel : LabelLogic;
  const convertBoolValueToString =
    name === customerAuthorized || name === customerAuthorizedValcan;

  return (
    <>
      <FieldWrapper>
        {/* {mainLabel && <p className="frg-body-font-14px">{mainLabel}</p>} */}
        {convertBoolValueToString ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              ref={ref}
              style={{
                marginRight: '1rem',
                height: '1.25rem',
                width: '1.25rem',
                borderRadius: '4px'
              }}
              type="checkbox"
              value={value || ''}
              id={name}
              name={name}
              checked={checked}
              onChange={onChange}
              disabled={readonly}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label style={{ color: 'red', cursor: 'pointer' }} htmlFor={name}>
              {label}
            </label>
          </div>
        ) : (
          <Checkbox
            id={name}
            name={name}
            value={value || ''}
            label={labelValue}
            checked={checked}
            onChange={onChange}
            disabled={readonly}
          />
        )}
      </FieldWrapper>
    </>
  );
};

FieldCheckbox.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    mainLabel: PropTypes.string,
    formFields: PropTypes.object,
    label: PropTypes.string,
    value: PropTypes.string,
    readonly: PropTypes.bool,
    longLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }).isRequired
};

export default FieldCheckbox;
